import React, { useState } from 'react'
import { message } from 'antd'
import moment from 'moment'

import { Text } from '../../Reusable/Text'
import { Flex, FlexColumn } from '../../Reusable/Container'
import { Button, TextButton } from '../../Reusable/Button'
import { LabeledInput } from '../../Reusable/Input'
import environment from '../../../environment'
import { apiPOSTReq } from '../../../Utils/api'
import { getRoleOptions } from '../../../Utils/util'
import { ErrorAlert } from '../../Reusable/Alert'
import CancelModal from '../../Reusable/CancelModal'
import { uaApiPOST } from '../../../Utils/userAccess'
import DeleteIcon from '../../../Images/delete-red-icon.png'
import { Trash } from 'lucide-react'
import { withTheme } from 'styled-components'

const UpdateUser = (props) => {
    const [last4Error, setLast4Error] = useState(false)
    const [expDateError, setExpDateError] = useState(false)
    const [submitLoading, setSubmitLoading] = useState(false)
    const [deleteLoading, setDeleteLoading] = useState(false)
    const [showDelete, setShowDelete] = useState(false)
    const [selectedRoles, setSelectedRoles] = useState(props.user.roleTags)
    const [firstName, setFirstName] = useState()
    const [lastName, setLastName] = useState()
    const [email, setEmail] = useState()
    const [phone, setPhone] = useState()

    const { user, allRoles, onUpdateRoles, aionStore } = props

    const canDeleteUser = (aionStore.UserInfo.Email !== user.Email) && !selectedRoles.includes("Primary Admin")

    const handleSelectRole = (role) => {
        setSelectedRoles(role)
    }

    const updateUser = () => {
        const { user } = props

        if(!selectedRoles || selectedRoles.length === 0) {
            ErrorAlert({ description: 'You must select at least one role' })
            return
        }

        var body = {
            RoleNames: selectedRoles,
            UserId: user.Email,
        }
        setSubmitLoading(true)
        uaApiPOST("/user/admin/updateUserRoles", { body: body }, (err, resp) => {
            try {
                setSubmitLoading(false)
                if (err) throw Error(err)
                if (!resp.result) throw Error(resp.responseMessage || resp.error)
                message.success('User roles updated')
                onUpdateRoles()
            } catch (error) {
                ErrorAlert({ description: error.message })
            }
        })
    }

    const deleteUser = () => {
        var body = {
            UserId: user.Email,
            deletedByUserEmail: aionStore.UserInfo.Email,
            deletedBy: aionStore.UserInfo.FirstName + " " + aionStore.UserInfo.LastName
        }
        setDeleteLoading(true)

        apiPOSTReq(`${environment.uamBaseUrl}/uam/deleteUser`, {}, body, (err, resp) => {
            try {
                setDeleteLoading(false)
                if (err) throw Error(err)
                if (!resp.result) throw Error(resp.responseMessage || resp.error)
                message.success('User deleted')
                onUpdateRoles()
            } catch (error) {
                ErrorAlert({ description: error.message })
            }
        })
    }

    return (
        <FlexColumn left>
            <Text heading>Manage User</Text>
            <Text style={{ marginBottom: 8, marginTop: 8 }}>{canDeleteUser ? 'Update role or delete user' : 'Update role'}</Text>
            <LabeledInput
                id='role'
                key='role'
                label='Roles'
                type='select'
                mode="multiple"
                placeholder='Select role/s'
                value={selectedRoles}
                maxLength={4}
                onChange={handleSelectRole}
            >
                {getRoleOptions(allRoles, [])}
            </LabeledInput>

            <Flex start centerH gap='16px' style={{ marginTop: '24px' }}>
                <Button
                    solid
                    radius='4px'
                    text='SAVE CHANGES'
                    onClick={() => updateUser()}
                    loading={submitLoading} 
                />

                {
                    // Cannot delete oneself and primary admins
                    canDeleteUser && 
                    <TextButton
                        text='DELETE USER'
                        leftIcon={<img width='24px' height='24px' src={DeleteIcon} />}
                        color={props.theme.colors.primary7}
                        onClick={() => setShowDelete(true)}
                        loading={deleteLoading}
                    />
                }
            </Flex>
            <CancelModal
                visible={showDelete}
                title={`Permanently delete ${user.FirstName} ${user.LastName}?`}
                description='Do you want to proceed? Once completed, this deletion cannot be reversed'
                buttonTitle='YES, DELETE'
                onConfirm={() => deleteUser()}
                onCancel={() => setShowDelete(false)} 
                loading={deleteLoading}
            />
        </FlexColumn>
    )
}

export default withTheme(UpdateUser)